import { render, staticRenderFns } from "./quotation-list.vue?vue&type=template&id=222c9257&scoped=true&"
import script from "./quotation-list.vue?vue&type=script&lang=js&"
export * from "./quotation-list.vue?vue&type=script&lang=js&"
import style0 from "./quotation-list.vue?vue&type=style&index=0&id=222c9257&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c9257",
  null
  
)

export default component.exports